import { IconButton, Image } from "@chakra-ui/react";
import {
  settings,
  logout,
  notification,
  hamburger,
  close,
  closeWhite,
  info,
  dots,
  trash,
  edit,
  iconArrowDown,
  iconArrowUp,
} from "../../assets/new-images/icons";
const icons = {
  settings,
  logout,
  notification,
  hamburger,
  close,
  closeWhite,
  info,
  dots,
  trash,
  edit,
  iconArrowDown,
  iconArrowUp,
};

export default function ButtonOnlyIcon({ name, iconHeight, ...rest }) {
  const Icon = icons[name];

  return (
    <IconButton
      bg="none"
      minW="unset"
      minH="unset"
      p={0}
      icon={<Image src={Icon} alt="" height={iconHeight || "24px"} />}
      _hover={{
        bg: "none",
      }}
      {...rest}
    />
  );
}
